import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppFloat from '../common/WhatsAppFloat';
import ChatAssistant from '../chat/ChatAssistant';
import CountdownBanner from '../common/CountdownBanner';
import SocialProofNotifications from '../common/SocialProofNotifications';
import ViewersNotification from '../common/ViewersNotification';
import SkipLink from '../common/SkipLink';

const MainLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SkipLink />
      <CountdownBanner />
      <Header />
      <main id="main-content" className="flex-1 pt-[68px]" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <ChatAssistant />
      <SocialProofNotifications />
      <ViewersNotification />
    </div>
  );
};

export default MainLayout;